import { Link } from 'react-router-dom';

export function CategoryCard({ category, size = 'normal' }) {
  const sizeClasses = {
    small: 'aspect-square',
    normal: 'aspect-[4/3]',
    large: 'aspect-[16/9] md:col-span-2'
  };

  return (
    <Link 
      to={`/categoria/${category.slug}`}
      className={`category-card group relative rounded-2xl overflow-hidden ${sizeClasses[size]}`}
      data-testid={`category-card-${category.slug}`}
    >
      {(category.image_url || category.image) ? (
        <img 
          src={category.image_url || category.image} 
          alt={category.name}
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-zinc-800 to-zinc-900" />
      )}
      
      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/50 to-transparent" />
      
      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 z-10">
        <h3 className="text-lg md:text-xl font-semibold text-zinc-100 mb-1 group-hover:text-white transition-colors font-[Outfit]">
          {category.name}
        </h3>
        {category.listing_count !== undefined && (
          <p className="text-sm text-zinc-400">
            {category.listing_count} {category.listing_count === 1 ? 'anuncio' : 'anuncios'}
          </p>
        )}
      </div>

      {/* Hover effect */}
      <div className="absolute inset-0 border-2 border-transparent group-hover:border-purple-500/30 rounded-2xl transition-colors" />
    </Link>
  );
}

export function CategoryGrid({ categories }) {
  if (!categories || categories.length === 0) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
      {categories.slice(0, 8).map((category, index) => (
        <CategoryCard 
          key={category.id || category.slug} 
          category={category}
          size={index === 0 || index === 5 ? 'large' : 'normal'}
        />
      ))}
    </div>
  );
}
